// Get the current time
export default (): number => new Date().getTime();
